export default __webpack_public_path__ + "static/media/1-1.1eb4b2a3.mp3";